import { useMedia } from "react-use";

/** True when the primary input supports hover (desktop pointer). False on most touch devices. */
export function usePrefersHover(defaultState = false) {
  return useMedia("(hover: hover) and (pointer: fine)", defaultState);
}
